import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TogetherDIPStageContainer } from './../models/app.models';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { TogetherAuctionDIPEntityType } from './../models/enums';
import { TogetherAuctionDIPQuoteResult } from './../models/api.models';
@Component({
    selector: 'together-auction-dip-outcome',
    templateUrl: './dip.outcome.component.html',
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPOutcomeComponent implements OnInit {

  @Input() stage: TogetherDIPStageContainer;
  @Input() incoming_case_id: string;
  @Output() stage_changing: EventEmitter<string> = new EventEmitter<string>();

  quote_result: TogetherAuctionDIPQuoteResult = new TogetherAuctionDIPQuoteResult(null);
  _isLoading: boolean = false;
  _notifications: Array<object> = [];

  constructor(private entity: NodeAPIEntityService) { }

  _clearErrors() {
    this._notifications = [];
  }

  _handleError(error) {
    this._notifications.push({ text: error.error.message });
  }

  _handleBindInitData() {

  }

  _prepareInitData() {

  }
  _handleInitData(case_id) {
    this._isLoading = true;
    this.entity.getAllEntities(TogetherAuctionDIPEntityType.SubmitQuote, case_id)
      .subscribe(
      (success) => {
        this.quote_result = new TogetherAuctionDIPQuoteResult(success);
        this._clearErrors();
        this._handleBindInitData();
        this._prepareInitData();
        this._isLoading = false;
      },
      (error) => {
        this._handleError(error);
        this._isLoading = false;
      },
      );
  }

  _handleInit() {
    // Is the entity not new? If so, let's get the details.
    if (this.entity.isNew(this.incoming_case_id) === false) {
      this._handleInitData(this.incoming_case_id);
    } else {
      // If we're not allowed to have a new reference, move.
      if (this.entity.allowNew(this.stage.current_stage.reference) === false) {
        this.stage_changing.emit('tad_stage_info');
        this._prepareInitData();
      }
    }
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this._handleInit();
  }

}
